import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import Nav from "@/components/Nav";

// Deep-link entrypoint for ads: /start
// If signed in → /case/new. Otherwise /auth?next=/case/new.
export default function StartRedirect() {
  const { user, loading } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (user) {
      nav("/case/new", { replace: true });
    } else {
      // Remember to send them to /case/new after auth
      try { sessionStorage.setItem("phr_post_auth_redirect", "/case/new"); } catch {}
      nav("/auth", { replace: true });
    }
  }, [user, loading, nav]);

  return (
    <div className="min-h-screen bg-[#FAFBFD]">
      <Nav />
      <div className="p-12 text-center text-slate-500" data-testid="start-redirect">Loading your case…</div>
    </div>
  );
}
